<template>
  <v-container class="ma-0 pa-0">
    <v-row>
      <v-col cols="5" class="py-0">
        <div>
          <v-btn
            v-if="!hideNavButtons && !hideNavBack"
            color="primary"
            outlined
            :disabled="loading"
            class="mr-2"
            @click="handleClickPrevStep"
          >
            Back
          </v-btn>
          <v-btn
            v-if="!hideNavButtons && !hideNavNext && !modal.delete"
            color="primary"
            outlined
            :disabled="loading || !!validation.length"
            class="mr-2"
            @click="handleClickNextStep"
          >
            Next
          </v-btn>
          <v-btn
            v-if="
              !hideNavButtons &&
              !hideNavFinish &&
              !modal.delete &&
              !modal.readOnly
            "
            color="primary"
            :disabled="loading || !!validation.length"
            class="mr-2"
            @click="handleClickFinish"
          >
            Finish
            <v-progress-circular
              v-if="loading"
              indeterminate
              size="14"
              width="2"
              class="ml-2"
            ></v-progress-circular>
          </v-btn>

          <v-btn text color="primary" @click="handleClickCancel">
            Cancel
          </v-btn>

          <v-btn
            v-show="isUpdate && !loading"
            color="red"
            outlined
            :disabled="modal.delete"
            class="ml-5"
            @click="handleClickDelete"
          >
            Delete
            <v-progress-circular
              v-if="modal.delete"
              indeterminate
              size="14"
              width="2"
              class="ml-2"
            ></v-progress-circular>
          </v-btn>
        </div>
      </v-col>
      <v-col cols="7" class="py-0">
        <v-alert
          v-if="validation && validation.length"
          border="left"
          colored-border
          type="error"
          elevation="2"
          class="my-0 hyp-alert application-heading"
        >
          {{ validation[0] }}
        </v-alert>
        <v-alert
          v-if="showFailedMessage"
          border="left"
          colored-border
          type="error"
          elevation="2"
          class="my-0 hyp-alert application-heading"
        >
          There was an issue saving, please try again.
        </v-alert>
        <v-alert
          v-if="modal.readOnly"
          border="left"
          colored-border
          type="info"
          elevation="2"
          class="my-0 hyp-alert application-heading"
        >
          This notification has been shared with you, therefore you cannot edit
          it.
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashDebounce from "lodash/debounce";

import { mapGetters } from "vuex";
import { MODULE_PREFIX_NOTIFICATIONS } from "@/store";

const EMITTED_ACTIONS = {
  CLICK_STEP_NEXT: "click-step-next",
  CLICK_STEP_PREV: "click-step-prev",
  CLICK_FINISH: "click-finish",
  CLICK_DELETE: "click-delete",
  CLICK_CANCEL: "click-cancel",
};

export default {
  name: "NotificationsModalFooter",
  components: {},
  props: {
    isUpdate: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Array,
      default() {
        return [];
      },
    },
    saveFailed: {
      type: Boolean,
    },
    hideNavButtons: {
      type: Boolean,
      default: false,
    },
    hideNavBack: {
      type: Boolean,
      default: false,
    },
    hideNavNext: {
      type: Boolean,
      default: false,
    },
    hideNavFinish: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    closeMessage: false,
  }),
  computed: {
    ...mapGetters({
      modal: MODULE_PREFIX_NOTIFICATIONS + "modal",
    }),
    showFailedMessage() {
      if (this.saveFailed) {
        lodashDebounce(() => {
          this.setCloseMessage(true);
        }, 5000)();
      } else {
        this.setCloseMessage(false);
      }
      return !this.closeMessage && this.saveFailed && !this.hideNavFinish;
    },
  },
  methods: {
    handleClickNextStep() {
      this.$emit(EMITTED_ACTIONS.CLICK_STEP_NEXT);
    },
    handleClickPrevStep() {
      this.$emit(EMITTED_ACTIONS.CLICK_STEP_PREV);
    },
    handleClickFinish() {
      this.$emit(EMITTED_ACTIONS.CLICK_FINISH);
    },
    handleClickDelete() {
      this.$emit(EMITTED_ACTIONS.CLICK_DELETE);
    },
    handleClickCancel() {
      this.$emit(EMITTED_ACTIONS.CLICK_CANCEL);
    },
    setCloseMessage(value) {
      this.closeMessage = value;
    },
  },
};
</script>

<style>
.hyp-alert .v-alert__content {
  font-size: 14px;
}
</style>

<style scoped>
.hyp-alert {
  position: relative;
  top: -10px;
}
</style>
